// @owners { team: patients }
import { DateRestrictionReasonMap } from '@alto/scriptdash/alto/scheduling/types/v1/date_restriction_reason';
import { formattedNextAvailableDate } from '~shared/features/next-available-date/helpers/formattedNextAvailableDate';

type Props = {
  earliestAvailableDate: string;
  earliestAvailableReason: string;
  isLoading: boolean;
  lineBreakDate?: boolean | null;
  excludeDayOfWeek?: boolean;
};

/**
 * Patient-facing NAD copy for cart footer / info rows.
 * Returns null when the UI should hide the date line (oos with no recovery date).
 */
export const getNextAvailableDateDisplayCopy = ({
  earliestAvailableDate,
  earliestAvailableReason,
  isLoading,
  lineBreakDate,
  excludeDayOfWeek,
}: Props): string | null => {
  if (isLoading) {
    return 'Refreshing...';
  }

  const isOutOfStockWithNoRecoveryDate =
    earliestAvailableReason === DateRestrictionReasonMap.OUT_OF_STOCK && !earliestAvailableDate;
  if (isOutOfStockWithNoRecoveryDate) {
    return null;
  }

  return (
    formattedNextAvailableDate(earliestAvailableDate, earliestAvailableReason, lineBreakDate, excludeDayOfWeek) ||
    'Unavailable'
  );
};
